import React, { type FC } from 'react';
import clsx from 'clsx';

interface CategoryLinkProps {
  isActive: boolean;
  onClick: () => void;
  children: React.ReactNode;
}

const CategoryLink: FC<CategoryLinkProps> = ({ isActive, onClick, children }) => (
  <div
    className={clsx(
      'px-5 py-2 rounded-full text-lg transition-colors duration-300 whitespace-nowrap cursor-pointer',
      isActive ? 'bg-black text-white' : 'text-secondary',
      'hover:bg-gray-200',
    )}
    onClick={onClick}
  >
    {children}
  </div>
);

export default CategoryLink;
